import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CustomerOrderDashboardComponent } from '../customer-order-dashboard/customer-order-dashboard.component';
import { OrderFulfillmentComponent } from '../order-fulfillment/order-fulfillment.component';
import { UserRole } from '../../../../core/enums/users/role';
import { UserStateService } from '../../../user/shared/services/user-state/user-state.service';

@Component({
    selector: 'app-order-dashboard-container',
    templateUrl: './order-dashboard-container.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CustomerOrderDashboardComponent, OrderFulfillmentComponent],
})
export class OrderDashboardContainerComponent {
    constructor(private readonly userStateService: UserStateService) {}

    /**
     * Determines if the current user has a customer role.
     */
    isCustomerView(): boolean {
        return this.userStateService.getRole() === UserRole.Customer;
    }
}
